import { useState, forwardRef } from "react";
import styles from "./Textarea.module.css";

const Textarea = forwardRef(
  (
    {
      value = "",
      onChange,
      onFocus,
      onBlur,
      name,
      id,
      placeholder = "",
      rows = 3,
      maxLength,
      showCharCount = true,
      disabled = false,
      readOnly = false,
      error = false,
      className = "",
      ...props
    },
    ref
  ) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = (e) => {
      setIsFocused(true);
      if (onFocus) onFocus(e);
    };

    const handleBlur = (e) => {
      setIsFocused(false);
      if (onBlur) onBlur(e);
    };

    const strValue = value !== null && value !== undefined ? String(value) : "";

    const wrapperClass = [
      styles.textareaWrapper,
      isFocused ? styles.focused : "",
      error ? styles.hasError : "",
      disabled ? styles.disabled : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div className={wrapperClass}>
        <textarea
          ref={ref}
          id={id || name}
          name={name}
          value={strValue}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          rows={rows}
          maxLength={maxLength}
          disabled={disabled}
          readOnly={readOnly}
          className={styles.textarea}
          {...props}
        />

        {showCharCount && maxLength && (
          <div className={styles.footerBar}>
            <span className={styles.charCounter}>
              {strValue.length}/{maxLength}
            </span>
          </div>
        )}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";

export default Textarea;
